import { render, staticRenderFns } from "./Worksheet.vue?vue&type=template&id=06beda32&lang=pug"
import script from "./Worksheet.vue?vue&type=script&lang=ts"
export * from "./Worksheet.vue?vue&type=script&lang=ts"
import style0 from "./Worksheet.vue?vue&type=style&index=0&id=06beda32&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QAvatar,QImg,QSeparator,QBtn,QDialog});
